var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(catalog){return _c('Catalog',{key:catalog.id,attrs:{"catalog":catalog,"items":_vm.items,"updatePrescription":_vm.updatePrescription}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }